import React from 'react';
import styled from 'styled-components';
import {useParams} from 'react-router';
import {usePreleadProjectQuery, usePreleadQuery} from 'api';
import useJobListing from 'hooks/useJobListing';
import moment from 'moment';

export default () => {
  const {preleadProjectId} = useParams<{preleadProjectId: string}>();
  if (!preleadProjectId) return null;

  const {data: {preleadProject = {}} = {}} = usePreleadProjectQuery({
    variables: {uuid: preleadProjectId},
    fetchPolicy: 'cache-and-network',
  });

  const {data: {prelead: {crawlerJobListingPages = []} = {}} = {}} =
    usePreleadQuery({
      variables: {uuid: preleadProject.prelead.uuid},
    });

  const {aggregatedJobListingsByMedia} = useJobListing(crawlerJobListingPages);

  return (
    <Container>
      <h2>求人情報</h2>
      {aggregatedJobListingsByMedia?.map((media) => {
        if (media.jobInformations?.length > 0) {
          return (
            <Media key={media.id}>
              <MediaName>{media.name}</MediaName>
              {media.jobInformations.map((info: any) => (
                <React.Fragment key={info.id}>
                  <label className="pl-2 text-c-light">
                    {info.date && moment(info.date).format('YYYY/MM/DD')}
                  </label>
                  <JobTitle key={info.id} href={info.url} target="_blank">
                    {info.title || info.url}
                  </JobTitle>
                </React.Fragment>
              ))}
              <BorderBottom />
            </Media>
          );
        }
      })}
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  > h2 {
    margin-bottom: 20px;
    font-weight: bold;
    font-size: 12px;
    color: var(--text-color-1);
  }
`;

const Media = styled.div`
  padding-bottom: 10px;
`;

const MediaName = styled.div`
  padding-bottom: 15px;
  font-family: Noto Sans JP;
  font-weight: bold;
  font-size: 15px;
  letter-spacing: 0.15px;
  color: var(--text-color-0);
`;

const JobTitle = styled.a`
  display: block;
  padding-left: 7px;
  margin-bottom: 8px;
  font-family: Noto Sans JP;
  font-size: 11px;
  letter-spacing: 0.15px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

const BorderBottom = styled.div`
  border-bottom: 0.5px solid var(--text-color-3);
  margin-bottom: 20px;
  padding-top: 20px;
`;
